// Anthology: swap the main product image to reflect the selected Birthstone
// Month value - and ONLY that option (Base Metal / Color changes are
// untouched). This is separate from the normal color/metal variant image
// swap mechanism: the birthstone photos are real product media (so Shopify
// can host and serve them), but media-gallery.liquid skips them when
// rendering the thumbnail rail (any media whose alt text contains
// "Birthstone swap:"), so they never show up as their own thumbnail.
//
// Because these images aren't real thumbnails, the swap doesn't go through
// theme.js's click handler at all - it just shows/hides the right
// .product-media element directly.
//
// theme.js's own ProductMediaGallery has a recurring bug: something in its
// periodic reflow/zoom code repeatedly re-shows the gallery's first photo
// without hiding whatever else is currently shown, so a second, wrong
// image can re-appear stacked underneath ours at any point, not just on
// first load. Rather than patch that shared, 137KB core file, this script
// re-asserts the correct photo on every watchdog tick (see setInterval
// below) so any stray re-show self-heals within ~1.5s. That re-assertion
// only happens while "following" the Birthstone Month selection - a
// manual thumbnail click switches off following (so periodic
// re-assertion can't fight the user's own choice) until the next
// Birthstone Month change turns it back on.
(function ($) {
  function normalizeStoneName(raw) {
    return (raw || '').replace(/\s*\(Simulated\)\s*$/i, '').trim().toLowerCase();
  }

  function getProductData($el) {
    var productId = $el.closest('.product-container').find('form.product-form').data('product-id');
    if (!productId) return null;
    var scriptEl = document.getElementById('ProductJson-' + productId);
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getProductMedia($gallery) {
    var data = getProductData($gallery);
    return (data && data.media) || null;
  }

  function findBirthstoneMediaId(productMedia, stoneName) {
    if (!productMedia || !stoneName) return null;
    var needle = 'birthstone swap: ' + stoneName;
    for (var i = 0; i < productMedia.length; i++) {
      var alt = (productMedia[i].alt || '').toLowerCase();
      if (alt.indexOf(needle) > -1) return productMedia[i].id;
    }
    return null;
  }

  function showOnlyMedia($gallery, mediaId) {
    var $all = $gallery.find('.main .product-media');
    $all.not('[data-media-id="' + mediaId + '"]').each(function () {
      // don't interrupt a playing video/3D model - only images are involved
      // in the birthstone swap, so leave other media types to theme.js
      if ($(this).data('media-type') === 'image') $(this).hide();
    });
    $all.filter('[data-media-id="' + mediaId + '"]').show();
  }

  function applyBirthstoneImage($gallery, rawValue) {
    var stoneName = normalizeStoneName(rawValue);
    var mediaId = findBirthstoneMediaId(getProductMedia($gallery), stoneName);
    if (!mediaId) return;
    showOnlyMedia($gallery, mediaId);
  }

  function bindBirthstoneWatch($gallery) {
    var $container = $gallery.closest('.product-container');
    var $select = $container.find('#option-birthstone-month');
    if (!$select.length) return;

    reassertBirthstoneImage($gallery); // follow mode: re-apply every watchdog tick

    if ($select.data('anthologyBirthstoneBound')) return;
    $select.data('anthologyBirthstoneBound', true);
    $gallery.data('anthologyBirthstoneFollow', true);

    $select.on('change.anthologyBirthstone', function () {
      $gallery.data('anthologyBirthstoneFollow', true);
      applyBirthstoneImage($gallery, $(this).val());
    });

    // A real thumbnail click (a different photo, or a color/metal swap that
    // changes the pictured variant) always wins over a birthstone swap -
    // re-assert single visibility immediately, and stop the watchdog from
    // re-showing the birthstone photo over it until Birthstone Month
    // changes again.
    $gallery.on('click.anthologyBirthstone', '.thumbnails .thumbnail', function () {
      $gallery.data('anthologyBirthstoneFollow', false);
      showOnlyMedia($gallery, $(this).data('media-id'));
    });

    applyBirthstoneImage($gallery, $select.val()); // match the pre-selected value on load
  }

  function reassertBirthstoneImage($gallery) {
    var $container = $gallery.closest('.product-container');
    var $select = $container.find('#option-birthstone-month');
    if (!$select.data('anthologyBirthstoneBound') || $gallery.data('anthologyBirthstoneFollow') === false) return;
    applyBirthstoneImage($gallery, $select.val());
  }

  // The Birthstone Month swatches are built by theme.js from a hidden
  // <select> (see clickyBoxes() in theme.js) as one flat list of <li>s, in
  // option order: all genuine stones, then all "(Simulated)" stones, inside
  // one <ul class="clickyboxes"> that theme.js binds its click handling and
  // underlying <select> reference to (via jQuery .data()). To show "Genuine
  // Stones" and "Simulated Stones" as two independently horizontally-
  // scrolling strips (Jewlr-style), each <li> is moved into one of two new
  // sub-<ul>s with a heading above each - but both sub-<ul>s stay nested
  // INSIDE the original <ul>, so theme.js's click delegation (bound to that
  // exact element) and its stored .data('select') keep working unchanged.
  function restructureBirthstoneList() {
    var $list = $('[data-name="Birthstone Month"] .clickyboxes');
    if (!$list.length || $list.data('anthologyRestructured')) return;
    var $lis = $list.children('li');
    if (!$lis.length) return;
    $list.data('anthologyRestructured', true);

    var $simulated = $lis.filter(function () {
      return /\(Simulated\)$/.test($(this).find('a').attr('data-value') || '');
    });
    var $genuine = $lis.not($simulated);

    var $genuineRow = $('<ul class="birthstone-scroll-row" role="list"></ul>').append($genuine);
    var $simulatedRow = $('<ul class="birthstone-scroll-row" role="list"></ul>').append($simulated);

    $list.empty().append(
      $('<div class="birthstone-group-heading"></div>').text('Genuine Stones'),
      $genuineRow,
      $('<div class="birthstone-group-heading"></div>').text('Simulated Stones'),
      $simulatedRow
    );
  }

  // Genuine gemstones are priced individually (set as an add-on over the
  // flat Base Metal price - simulated stones carry no extra charge). Show
  // that add-on next to each genuine swatch, Jewlr-style, computed live from
  // the variant data in ProductJson so it always matches whatever Base
  // Metal/Color is currently selected.
  var BASE_METAL_PRICE = {
    'STERLING SILVER': 148.95,
    '14K GOLD': 989.90,
    'BRASS': 82.50
  };

  function formatAddon(amount) {
    var rounded = Math.round(amount * 100) / 100;
    var isWhole = Math.abs(rounded - Math.round(rounded)) < 0.001;
    return '+$' + (isWhole ? Math.round(rounded) : rounded.toFixed(2));
  }

  function updateBirthstonePrices() {
    var $list = $('[data-name="Birthstone Month"] .clickyboxes');
    if (!$list.length) return;
    var data = getProductData($list);
    if (!data || !data.variants) return;

    var $container = $list.closest('.product-container');
    var metal = $container.find('#option-base-metal').val();
    var color = $container.find('#option-color').val();
    var basePrice = metal && BASE_METAL_PRICE[metal.toUpperCase()];
    if (basePrice == null) return;

    var variants = data.variants;
    $list.find('li a[data-value]').each(function () {
      var $a = $(this);
      var stoneValue = $a.attr('data-value');
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 === metal && v.option2 === color && v.option3 === stoneValue) {
          variant = v;
          break;
        }
      }
      var $priceSpan = $a.find('.birthstone-price-addon');
      if (!$priceSpan.length) $priceSpan = $('<span class="birthstone-price-addon"></span>').appendTo($a);
      if (!variant) {
        $priceSpan.text('');
        return;
      }
      var addon = (variant.price / 100) - basePrice;
      $priceSpan.text(addon > 0.004 ? formatAddon(addon) : '');
    });
  }

  function bindMetalColorWatch() {
    var $container = $('[data-name="Birthstone Month"] .clickyboxes').closest('.product-container');
    if (!$container.length || $container.data('anthologyPriceWatchBound')) return;
    $container.data('anthologyPriceWatchBound', true);
    $container.find('#option-base-metal, #option-color').on('change.anthologyBirthstonePrice', updateBirthstonePrices);
  }

  // Once a swatch sits under the "Simulated Stones" heading, the "(Simulated)"
  // suffix in its own label is redundant - strip it from the visible text
  // only (data-value keeps the full name, since that's what the CSS class
  // matching and normalizeStoneName() above rely on).
  function stripSimulatedLabels() {
    $('[data-name="Birthstone Month"] .clickyboxes li a[data-value$="(Simulated)"]').each(function () {
      if ($(this).data('anthologyLabelStripped')) return;
      $(this).data('anthologyLabelStripped', true);
      this.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.nodeValue = node.nodeValue.replace(/\s*\(Simulated\)\s*/i, ' ');
        }
      });
    });
  }

  function initAll() {
    $('.product-gallery').each(function () {
      bindBirthstoneWatch($(this));
    });
    restructureBirthstoneList();
    stripSimulatedLabels();
    bindMetalColorWatch();
    updateBirthstonePrices();
  }

  // See the file-level comment above for why the first run is deferred by
  // one tick (theme.js's own gallery init otherwise runs after this script
  // and clobbers the swap).
  function deferredInitAll() {
    setTimeout(initAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInitAll);
  } else {
    deferredInitAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  setInterval(initAll, 1500);
})(jQuery);
